/**
 * Approach 2: product cards as native Web Components (imperative DOM inside &lt;mob-product-card&gt;).
 */
import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useContextData } from '../../ApiContext';
import { MOB_PRODUCTS_PAGE_SIZE } from '../../Slider/SliderMobNew';
import { ProductGridSkeleton } from '../../Components/images/Mob/ProductGridSkeleton';
import { fetchMobProductsFirstPage } from './mobProductsFirstPage';
import './web-components/mob-product-card.js';
import './MobProductsWebComponentsPage.scss';

const NAV_EVENT = 'mob-product-navigate';

export function MobProductsWebComponentsPage() {
    const navigate = useNavigate();
    const { queryParams, setQueryParams } = useContextData();
    const [queryParamsInit, setQueryParamsInit] = useState(false);
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        setQueryParams({
            category: [],
            subcategory: [],
            price: [0, 10000],
        });
        setQueryParamsInit(true);
    }, [setQueryParams]);

    useEffect(() => {
        const onNav = (e) => {
            const id = e.detail?.id;
            if (id) navigate(`/specific/${id}`);
        };
        window.addEventListener(NAV_EVENT, onNav);
        return () => window.removeEventListener(NAV_EVENT, onNav);
    }, [navigate]);

    useEffect(() => {
        if (!queryParamsInit) return;
        let cancelled = false;
        const run = async () => {
            setLoading(true);
            setError(null);
            try {
                const mapped = await fetchMobProductsFirstPage(queryParams);
                if (!cancelled) setItems(mapped);
            } catch (e) {
                if (!cancelled) {
                    setError(e?.response?.data?.message || e?.message || 'Failed to load');
                    setItems([]);
                }
            } finally {
                if (!cancelled) setLoading(false);
            }
        };
        run();
        return () => {
            cancelled = true;
        };
    }, [queryParams, queryParamsInit]);

    return (
        <div className="mob-wc-page">
            <header className="mob-wc-page__header">
                <Link to="/" className="mob-wc-page__back">
                    ← Home
                </Link>
                <h1 className="mob-wc-page__title">Approach: Web Components</h1>
                <p className="mob-wc-page__sub">
                    Same <code>POST /products</code> first page. Each <code>&lt;mob-product-card&gt;</code> is a
                    custom element with imperative DOM. Tap the image to cycle photos; &quot;View product&quot;
                    opens PDP via a window event handled by React Router.
                </p>
            </header>

            {loading ? (
                <ProductGridSkeleton cells={MOB_PRODUCTS_PAGE_SIZE} />
            ) : error ? (
                <p className="mob-wc-page__error" role="alert">
                    {error}
                </p>
            ) : (
                <div className="mob-wc-page__grid">
                    {items.map((product) => (
                        <mob-product-card
                            key={product.id}
                            ref={(el) => {
                                if (el) el.product = product;
                            }}
                        />
                    ))}
                </div>
            )}
        </div>
    );
}
